import { useQuery } from '@tanstack/react-query';
import { useRequest } from '~/lib/useRequest';
import { ProgramsPagePropsHttpResponse } from '@ab/ams-school-api/types/private/v1';
import { config } from '~/config';

export type ReferenceData = ProgramsPagePropsHttpResponse['body']['referenceData'];
export type InitialQueryParameter = ProgramsPagePropsHttpResponse['body']['initialQueryParameters'];

export type ProgramCatalogPageInitialProps = {
  referenceData: ReferenceData;
  initialQueryParameters: InitialQueryParameter;
};

export function useProgramCatalogPageProps() {
  const request = useRequest();
  const { isLoading, data, isError, error } = useQuery({
    queryKey: ['useProgramCatalogPageProps'],
    queryFn: async () => {
      const response = await request<ProgramsPagePropsHttpResponse['body']>(
        `${config.apiHost}/private/v1/programs/page_props`,
        { isExpectedResponse, method: 'GET' }
      );

      const sortValues = response.initialQueryParameters.sort.split(',');
      const sort = sortValues.length > 0 ? sortValues[0] : '-createdAt';

      return {
        referenceData: response.referenceData,
        initialQueryParameters: { sort, pageSize: response.initialQueryParameters.pageSize },
      };
    },
  });
  return {
    isInitialPropsError: isError,
    initialPropsError: error,
    isLoadingInitialProps: isLoading,
    initialProps: data,
  };
}

function isExpectedResponse(res: unknown): res is ProgramsPagePropsHttpResponse['body'] {
  return Boolean(res && typeof res === 'object');
}
